// extracted by mini-css-extract-plugin
export default {"topCaptionContainer":"CandidateVarietiesTable_topCaptionContainer__c6fXp","topCaptionContent":"CandidateVarietiesTable_topCaptionContent__zHcZh"};